import { render, staticRenderFns } from "./ReferenceCard.vue?vue&type=template&id=1a0daaf5"
import script from "./ReferenceCard.vue?vue&type=script&lang=js"
export * from "./ReferenceCard.vue?vue&type=script&lang=js"
import style0 from "./ReferenceCard.vue?vue&type=style&index=0&id=1a0daaf5&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports